import { SdsTooltipVariant } from '@superbet-group/web.lib.ui-components';

export const orientation = ['auto', 'vertical', 'horizontal', 'top', 'bottom', 'left', 'right'] as const;

export type Orientation = typeof orientation[number];

export type TooltipDefinition = {
    orientation: Orientation;
    variant: SdsTooltipVariant;
    text: string;
    hotkeys?: string;
    isHtml?: boolean;
    isRaw?: boolean;
};
